// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo-preview {
    padding-top: 100px;
    padding-bottom: 10px;
    margin: auto;
    width: 50%;
    text-align: center;
  }
  
  .progress {
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: none;
  }
  
  .progress.progress-xs {
    height: 5px;
    margin-top: 5px;
  }
  
  .progress.progress-sm {
    height: 10px;
    margin-top: 5px;
  }
  
  .progress.progress-lg {
    height: 25px;
  }
  
  .progress.vertical {
    position: relative;
    width: 20px;
    height: 200px;
    display: inline-block;
    margin-right: 10px;
  }
  
  .progress.vertical > .progress-bar {
    width: 100% !important;
    position: absolute;
    bottom: 0;
  }
  
  .progress.vertical.progress-xs {
    width: 5px;
    margin-top: 5px;
  }
  
  .progress.vertical.progress-sm {
    width: 10px;
    margin-top: 5px;
  }
  
  .progress.vertical.progress-lg {
    width: 30px;
  }
  
  .progress-bar {
    background-color: #2196F3;
    box-shadow: none;
  }
  
  .progress-bar.text-left {
    text-align: left;
  }
  
  .progress-bar.text-left span {
    margin-left: 10px;
  }
  
  .progress-bar.text-right {
    text-align: right;
  }
  
  .progress-bar.text-right span {
    margin-right: 10px;
  }
  
  .progress-striped .progress-bar,
  .progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 40px 40px;
  }
  
  @keyframes progress-bar-stripes {
    from {
      background-position: 40px 0;
    }
    to {
      background-position: 0 0;
    }
  }
  
  .progress.active .progress-bar,
  .progress-bar.active {
    animation: progress-bar-stripes 1s linear infinite;
  }
  
  .progress-bar-secondary {
    background-color: #323a45;
  }
  
  .progress-bar-default {
    background-color: #B0BEC5;
  }
  
  .progress-bar-success {
    background-color: #64DD17;
  }
  
  .progress-bar-info {
    background-color: #29B6F6;
  }
  
  .progress-bar-warning {
    background-color: #FFD600;
  }
  
  .progress-bar-danger {
    background-color: #ef1c1c;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ui/progressloader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,qMAAqM;IACrM,0BAA0B;EAC5B;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;;EAEA;;IAEE,kDAAkD;EACpD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".demo-preview {\n    padding-top: 100px;\n    padding-bottom: 10px;\n    margin: auto;\n    width: 50%;\n    text-align: center;\n  }\n  \n  .progress {\n    background-color: #ffffff;\n    border-radius: 3px;\n    box-shadow: none;\n  }\n  \n  .progress.progress-xs {\n    height: 5px;\n    margin-top: 5px;\n  }\n  \n  .progress.progress-sm {\n    height: 10px;\n    margin-top: 5px;\n  }\n  \n  .progress.progress-lg {\n    height: 25px;\n  }\n  \n  .progress.vertical {\n    position: relative;\n    width: 20px;\n    height: 200px;\n    display: inline-block;\n    margin-right: 10px;\n  }\n  \n  .progress.vertical > .progress-bar {\n    width: 100% !important;\n    position: absolute;\n    bottom: 0;\n  }\n  \n  .progress.vertical.progress-xs {\n    width: 5px;\n    margin-top: 5px;\n  }\n  \n  .progress.vertical.progress-sm {\n    width: 10px;\n    margin-top: 5px;\n  }\n  \n  .progress.vertical.progress-lg {\n    width: 30px;\n  }\n  \n  .progress-bar {\n    background-color: #2196F3;\n    box-shadow: none;\n  }\n  \n  .progress-bar.text-left {\n    text-align: left;\n  }\n  \n  .progress-bar.text-left span {\n    margin-left: 10px;\n  }\n  \n  .progress-bar.text-right {\n    text-align: right;\n  }\n  \n  .progress-bar.text-right span {\n    margin-right: 10px;\n  }\n  \n  .progress-striped .progress-bar,\n  .progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: 40px 40px;\n  }\n  \n  @keyframes progress-bar-stripes {\n    from {\n      background-position: 40px 0;\n    }\n    to {\n      background-position: 0 0;\n    }\n  }\n  \n  .progress.active .progress-bar,\n  .progress-bar.active {\n    animation: progress-bar-stripes 1s linear infinite;\n  }\n  \n  .progress-bar-secondary {\n    background-color: #323a45;\n  }\n  \n  .progress-bar-default {\n    background-color: #B0BEC5;\n  }\n  \n  .progress-bar-success {\n    background-color: #64DD17;\n  }\n  \n  .progress-bar-info {\n    background-color: #29B6F6;\n  }\n  \n  .progress-bar-warning {\n    background-color: #FFD600;\n  }\n  \n  .progress-bar-danger {\n    background-color: #ef1c1c;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
